import React from "react";
import { PieChart } from "react-minimal-pie-chart";
function PaiChart() {
  const defaultLabelStyle = {
    fontSize: "5px",
    fontFamily: "sans-serif",
  };
  return (
    <div
      style={{
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",
        paddingBottom: 20,
      }}
    >
      <PieChart
        className="pt-3"
        children="new"
        lineWidth={30}
        label={({ dataEntry }) => dataEntry.value}
        labelStyle={{ ...defaultLabelStyle }}
        totalValue={100}
        data={[
          { title: "Active Requests", value: 10, color: "#55b42d" },
          { title: "Completed Requests", value: 15, color: "#22886e" },
          { title: "Cancelled Requests", value: 20, color: "#e28495" },
        ]}
      />
    </div>
  );
}

export default PaiChart;
